import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCartShopping = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 576 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288h339c26 0 48.6-17.9 54.5-43.3L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L512.9 241.1c-4.2 18.1-20.4 30.9-39 30.9H131.8L88 48zm56 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" })
});
export default SvgCartShopping;
